const questions = [
  {
    sectionId: 'basic_info',
    category: '基本資訊',
    question: '請輸入您的電子郵件地址： ',
    type: 'text',
    name: 'email_address',
    meta: true
  },
  {
    sectionId: 'basic_info',
    category: '基本資訊',
    question: '1) 你孩子的年齡區間是？多位孩子可選多項',
    type: 'checkbox',
    name: 'child_ages',
    options: [
      { answer: '0-5 歲', value: 'a' },
      { answer: '6-10 歲', value: 'b' },
      { answer: '11-15 歲', value: 'c' },
      { answer: '16 歲或以上', value: 'd' }
    ],
    points: null
  },
  {
    sectionId: 'basic_info',
    category: '基本資訊',
    question: '2) 你現在在哪個國家居住？',
    type: 'text',
    name: 'country'
  },
  {
    sectionId: 'basic_info',
    category: '基本資訊',
    question: '3) 你的孩子目前在什麼類型的學校上學？',
    type: 'checkbox',
    name: 'school_type',
    options: ['公立學校', '私立學校', '國際學校', '寄宿學校', '另類教育/在家教育', '我的孩子已經成年/還沒上學', '其他']
  },

  {
    sectionId: 'family_env',
    category: '家庭中的數碼健康環境',
    question: '4) 你孩子平日平均會接觸多久的電子螢幕（不含學習時間）？',
    type: 'radio',
    name: 'screentime',
    options: [
      { answer: '每天 0 - 2.5 小時', value: 'a' },
      { answer: '每天 2.5 - 4 小時', value: 'b' },
      { answer: '每天 4 - 6 小時', value: 'c' },
      { answer: '每天 6 小時以上', value: 'd' }
    ],
    scoring: (answers) => {
      const child_ages = answers['child_ages'] || [];
      const screentime = answers['screentime'];
      if (screentime === 'a' && child_ages.includes('a')) {
return 1;
}
      if (screentime === 'b' && !child_ages.includes('a')) {
return 2;
}
      return 0;
    }
  },
  {
    sectionId: 'family_env',
    category: '家庭中的數碼健康環境',
    question: '5) 你對孩子經常使用的數碼平台與應用程式熟悉嗎？',
    type: 'likert',
    name: 'app_familiarity',
    options: [
      { answer: '我對它們幾乎完全不了解', points: 0 },
      { answer: '我了解部分運作方式，但不是全部都熟悉', points: 1 },
      { answer: '我對它們都很熟悉', points: 2 }
    ]
  },
  {
    sectionId: 'family_env',
    category: '家庭中的數碼健康環境',
    question:
      '6) 你是否有信心為孩子篩選健康的媒體內容與螢幕活動（如影片、遊戲等）？',
    type: 'likert',
    name: 'confident_ability',
    options: [
      { answer: '完全沒有信心', points: 0 },
      { answer: '有一定信心', points: 1 },
      { answer: '非常有信心', points: 2 }
    ]
  },
  {
    sectionId: 'family_env',
    category: '家庭中的數碼健康環境',
    question:
      '7) 你是否有信心能引導孩子合理分配電子產品使用時間與其他活動時間？',
    type: 'likert',
    name: 'confident_guide',
    options: [
      { answer: '完全沒有信心', points: 0 },
      { answer: '有一定信心', points: 1 },
      { answer: '非常有信心', points: 2 }
    ]
  },
  {
    sectionId: 'family_env',
    category: '家庭中的數碼健康環境',
    question:
      '8) 你通常多久會和孩子溝通一次，以了解他們對網路內容的看法與感受？',
    type: 'likert',
    name: 'talk_online_activity',
    options: [
      { answer: '幾乎不會談論', points: 0 },
      { answer: '偶爾會談論', points: 1 },
      { answer: '非常頻繁', points: 2 }
    ]
  },
  {
    sectionId: 'family_env',
    category: '家庭中的數碼健康環境',
    question:
      '9) 你通常多久與孩子溝通一次，以了解他們的網路活動？',
    type: 'likert',
    name: 'talk_learning',
    options: [
      { answer: '幾乎不會談論', points: 0 },
      { answer: '偶爾會談論', points: 1 },
      { answer: '非常頻繁', points: 2 }
    ]
  },
  {
    sectionId: 'family_env',
    category: '家庭中的數碼健康環境',
    question: '10) 你的孩子經常在電子螢幕前就餐嗎？',
    type: 'likert',
    name: 'meal_screen',
    options: [
      { answer: '他／她幾乎不在螢幕前吃飯', points: 4 },
      { answer: '他／她每週五次以上在螢幕前吃飯', points: 2 },
      { answer: '他／她每天至少在螢幕前吃一次', points: 0 }
    ]
  },
  {
    sectionId: 'family_env',
    category: '家庭中的數碼健康環境',
    question:
      '11) 你是否已在孩子使用的所有設備與線上服務（如 iPad、手機、筆電、Netflix、Roblox 等）設定家長監護模式？',
    type: 'likert',
    name: 'parental_controls',
    options: [
      { answer: '我目前不太清楚什麼是家長監護模式', points: 0 },
      { answer: '尚未設定，但想知道怎麼做', points: 1 },
      { answer: '部分設備已設定，其他尚未', points: 2 },
      { answer: '是的，所有設備與平台都已設定', points: 3 }
    ]
  },
  {
    sectionId: 'family_env',
    category: '家庭中的數碼健康環境',
    question: '12) 你是否對孩子獲得第一支手機的年齡有任何計畫或想法？',
    type: 'likert',
    name: 'prep_phone',
    options: [
      { answer: '我暫時沒有任何想法', value: 'a' },
      { answer: '我有初步想法，也願意了解更多', value: 'b' },
      { answer: '是的，我已和伴侶討論過具體想法', value: 'c' }
    ],
    scoring: (answers) => {
      const child_ages = answers['child_ages'] || [];
      const prep_phone = answers['prep_phone'];
      if (prep_phone === 'a' && !child_ages.includes('a')) {
return 0;
}
      if (prep_phone === 'b' && !child_ages.includes('a')) {
return 1;
}
      if (prep_phone === 'c') {
return 2;
}
      return 0;
    }
  },

  // 家庭在數碼健康與 AI 的溝通
  {
    sectionId: 'family_ai_comms',
    category: '家庭在數碼健康與人工智慧方面的溝通',
    question: '13) 你對孩子了解如何安全地使用數碼設備有多大的信心？',
    type: 'likert',
    name: 'digital_safety',
    options: [
      { answer: '完全沒有信心', points: 0 },
      { answer: '不是很有信心', points: 1 },
      { answer: '有一定信心', points: 2 },
      { answer: '非常有信心', points: 3 }
    ]
  },
  {
    sectionId: 'family_ai_comms',
    category: '家庭在數碼健康與人工智慧方面的溝通',
    question:
      '14) 你對孩子的親密朋友懂得如何安全使用數碼設備有多大的信心？',
    type: 'likert',
    name: 'friends_safety',
    options: [
      { answer: '完全沒有信心', value: 'a' },
      { answer: '不是很有信心', value: 'b' },
      { answer: '有一定信心', value: 'c' },
      { answer: '非常有信心', value: 'd' }
    ],
    scoring: (answers) => {
      const v = answers['friends_safety'];
      if (v === 'a') {
return 0;
}
      if (v === 'b') {
return 1;
}
      if (v === 'c') {
return 2;
}
      if (v === 'd') {
return 3;
}
    }
  },
  {
    sectionId: 'family_ai_comms',
    category: '家庭在數碼健康與人工智慧方面的溝通',
    question:
      '15) 據你所知，你的孩子是否頻繁使用生成式人工智慧（Gen-AI）？',
    type: 'likert',
    name: 'ai_usage',
    options: [
      { answer: '他／她幾乎不用', value: 'a' },
      { answer: '我不確定', value: 'b' },
      { answer: '很少用', value: 'c' },
      { answer: '有些頻繁（每週用幾次）', value: 'd' },
      { answer: '非常頻繁（幾乎每天）', value: 'e' }
    ],
    scoring: (answers) => {
      const friends_safety = answers['friends_safety'] || [];
      const ai_usage = answers['ai_usage'];
      if (ai_usage === 'a') {
return 1;
}
      if (ai_usage === 'b') {
return 0;
}
      if (ai_usage === 'c') {
return 2;
}
      if (ai_usage === 'd' && (friends_safety === 'a' || friends_safety === 'b')) {
return 1;
}
      if (ai_usage === 'e' && (friends_safety === 'a' || friends_safety === 'b')) {
return 0;
}
      return 0;
    }
  },
  {
    sectionId: 'family_ai_comms',
    category: '家庭在數碼健康與人工智慧方面的溝通',
    question:
      '16) 如果孩子在網路上遇到不好的事情，你覺得他們有多大可能會先來找你求助？',
    type: 'likert',
    name: 'parent_help',
    options: [
      { answer: '我不太清楚', points: 0 },
      { answer: '他們會先找朋友、兄弟姐妹或其他可信賴的成年人', points: 1 },
      { answer: '他們遇到問題通常會先找我', points: 2 }
    ]
  },
  {
    sectionId: 'family_ai_comms',
    category: '家庭在數碼健康與人工智慧方面的溝通',
    question:
      '17) 你會否把 Wi-Fi 或裝置使用權作為管教方式（例如不聽話就沒收手機或暫停上網）？',
    type: 'likert',
    name: 'access_discipline',
    options: [
      { answer: '不會', points: 2 },
      { answer: '有時會', points: 1 },
      { answer: '經常會', points: 0 }
    ]
  },

  {
    sectionId: 'resourcefulness',
    category: '父母的應變能力與自我效能感',
    question: '18) 對於與孩子討論以下主題，你感到有多自在？',
    type: 'grouped_likert',
    name: 'comfortable_discussing',
    subQuestions: [
      { label: '社交媒體與身體形象', name: 'comfortable_social_media' },
      { label: '心理健康與情緒福祉', name: 'comfortable_mental_health' },
      { label: '上網安全意識', name: 'comfortable_safety' },
      { label: '網路霸凌', name: 'comfortable_cyberbullying' },
      { label: '打遊戲／遊戲成癮', name: 'comfortable_gaming' },
      { label: '人工智慧助手', name: 'comfortable_ai' },
      { label: '深偽（Deepfakes）／虛假資訊', name: 'comfortable_deepfakes' }
    ],
    options: [
      { answer: '非常不自在', points: 0 },
      { answer: '不自在', points: 0 },
      { answer: '尚算自在', points: 1 },
      { answer: '非常自在', points: 4 }
    ]
  },
  {
    sectionId: 'resourcefulness',
    category: '父母的應變能力與自我效能感',
    question:
      '19) 當孩子在網上看到令人不安或困惑的內容（如天災、戰爭暴力、色情資訊等）並向你提問時，你是否已準備好如何回應？',
    type: 'likert',
    name: 'danger_prepared',
    options: [
      { answer: '沒有，我從未想過，也不清楚如何行動', points: 0 },
      { answer: '有一些想法，但不確定如何與他／她對話', points: 2 },
      { answer: '是的，我已做好與孩子溝通的準備', points: 3 }
    ]
  },
  {
    sectionId: 'resourcefulness',
    category: '父母的應變能力與自我效能感',
    question:
      '20) 你對於在下列行為中為孩子樹立榜樣這件事有多大的信心？',
    type: 'grouped_likert',
    name: 'role_model',
    subQuestions: [
      { label: '在螢幕與其他活動之間合理分配時間', name: 'rolemodel_screen_balance' },
      { label: '不在電子螢幕前就餐', name: 'rolemodel_no_screen_meals' },
      { label: '專注地與他人共度美好時光（不被裝置打擾）', name: 'rolemodel_inperson_time' },
      { label: '起床後與睡前不使用電子設備', name: 'rolemodel_no_morning_nighttech' },
      { label: '維持網路安全，不過度分享個資或照片', name: 'rolemodel_online_safety' },
      { label: '在網路上禮貌溝通並遵守數碼禮儀', name: 'rolemodel_respect_online' },
      { label: '懂得在需要時主動遠離裝置以維持情緒與心理健康', name: 'rolemodel_take_breaks' },
      { label: '負責任且有效地使用人工智慧', name: 'rolemodel_ai_use' }
    ],
    options: [
      { answer: '非常不自信', points: 0 },
      { answer: '不自信', points: 0 },
      { answer: '比較自信', points: 2 },
      { answer: '非常自信', points: 4 }
    ]
  },

  {
    sectionId: 'school_parent_comm',
    category: '學校與家長溝通',
    question:
      '21) 目前針對家人的數碼素養與人工智慧教育，你最關注哪些面向？（可複選）',
    type: 'checkbox',
    name: 'biggest_concerns',
    options: [
      '處理孩子已有的特定數碼問題（遊戲成癮、社群沉迷、時間管理困難）',
      '保護孩子遠離網路詐騙與不良分子',
      '教導孩子辨識網路霸凌',
      '培養孩子以批判性思維辨別虛假資訊與深偽內容',
      '為孩子建立健康的數碼習慣與良好心理素質',
      '在數碼時代維持穩固的家庭價值觀與親子關係',
      '預防沉迷性數碼行為（遊戲成癮、網購成癮、社群媒體過度使用）',
      '引導孩子善用人工智慧工具促進學業與未來發展',
      '其他（填寫）'
    ]
  },
  {
    sectionId: 'school_parent_comm',
    category: '學校與家長溝通',
    question:
      '22) 你是否曾收到孩子學校發送關於人工智慧與數碼健康的電郵或通訊？',
    type: 'likert',
    name: 'school_communication',
    options: [
      { answer: '完全沒印象收過', points: 0 },
      { answer: '可能收過，但不確定', points: 1 },
      { answer: '有，記得收過好幾次', points: 2 },
      { answer: '不適用', points: 1 }
    ]
  },
  {
    sectionId: 'school_parent_comm',
    category: '學校與家長溝通',
    question:
      '23) 你的學校是否為家長提供與數碼教養相關的培訓、講座或工作坊？',
    type: 'likert',
    name: 'parent_training',
    options: [
      { answer: '完全沒有提供', points: 0 },
      { answer: '有提供但仍不足夠', points: 1 },
      { answer: '經常提供', points: 2 },
      { answer: '不適用', points: 1 }
    ]
  },
  {
    sectionId: 'school_parent_comm',
    category: '學校與家長溝通',
    question:
      '24) 你對學校培養孩子數碼健康與人工智慧能力的信心程度？',
    type: 'likert',
    name: 'school_prep',
    options: [
      { answer: '完全沒信心', points: 0 },
      { answer: '不太有信心', points: 1 },
      { answer: '略有信心', points: 2 },
      { answer: '非常有信心', points: 3 }
    ]
  },
  {
    sectionId: 'school_parent_comm',
    category: '學校與家長溝通',
    question:
      '25) 學校是否發生過與網路霸凌、遊戲成癮或不當使用科技相關的事件？',
    type: 'likert',
    name: 'cyberbullying_incidents',
    options: [
      { answer: '沒有發生', points: 2 },
      { answer: '是的，但我了解不多', points: 1 },
      { answer: '是的，近期有幾起類似事件', points: 0 }
    ]
  },
  {
    sectionId: 'school_parent_comm',
    category: '學校與家長溝通',
    question:
      '26) 若遇到數碼教養、AI 教育、社群媒體或網路霸凌等問題，你會優先透過哪些管道尋求解答？（請排序）',
    type: 'ranking',
    name: 'parenting_resources',
    options: [
      'Google 搜尋',
      '人工智慧助手',
      '孩子就讀學校',
      '孩子的醫生／心理專家',
      '配偶／親友／信任的家長群',
      '社群媒體親子頻道',
      '其他：_____'
    ]
  },
  {
    sectionId: 'school_parent_comm',
    category: '學校與家長溝通',
    question: '27) 你希望學校提供哪些資訊或培訓？（可複選）',
    type: 'checkbox',
    name: 'more_info',
    options: [
      '如何處理具體數碼行為問題（遊戲成癮、社群沉迷、時間管理）',
      '如何保護孩子遠離網路詐騙與不良分子',
      '如何教導孩子應對網路霸凌',
      '如何培養孩子以批判性思維辨別虛假資訊與深偽內容',
      '如何奠定數碼與心理健康基礎',
      '如何在數碼時代維持家庭價值觀與親子關係',
      '如何預防沉迷性數碼行為（遊戲成癮、網購成癮、社群媒體過度使用）',
      '如何引導孩子善用人工智慧工具促進學業與職涯發展',
      '其他（請註明）'
    ]
  },
  {
    sectionId: 'school_parent_comm',
    category: '學校與家長溝通',
    question: '28) 在資訊或培訓方面，你更希望學校提供：',
    type: 'checkbox',
    name: 'info_trainings',
    options: ['參與實體工作坊／家長茶座', '參加線上活動', '訂閱附育兒資源的電子通訊']
  },
  {
    sectionId: 'school_parent_comm',
    category: '學校與家長溝通',
    question:
      '29) 如果學校提供一位專屬的 AI 諮詢虛擬顧問（可在家向其諮詢數碼教養與健康問題），你有多大可能會使用？',
    type: 'likert',
    name: 'ai_coach',
    options: ['絕對不會', '不太可能', '有點可能', '很有可能']
  },
  {
    sectionId: 'school_parent_comm',
    category: '學校與家長溝通',
    question:
      '30) 如果您回答“不太可能或絕對不會使用它”，您最擔心的是什麼？如果您沒有任何顧慮，請輸入「無」（開啟簡短的文字回覆）',
    type: 'text',
    name: 'main_concern'
  }
];

export default questions;
